"use client";

/**
 * P9-07 · Live online/offline status from the browser's `navigator.onLine` plus
 * the `online`/`offline` events. Built on `useSyncExternalStore` so the first
 * client render already reflects reality (no post-mount flash) and SSR is a
 * stable `true` (assume connected until the client says otherwise — never flash
 * an offline banner during hydration).
 */
import * as React from "react";

function subscribe(onChange: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

function getSnapshot(): boolean {
  // `navigator.onLine === false` is reliable (the browser knows it's offline);
  // `true` can be optimistic, which is the right default for a connectivity hint.
  return typeof navigator === "undefined" ? true : navigator.onLine;
}

export function useOnlineStatus(): boolean {
  return React.useSyncExternalStore(subscribe, getSnapshot, () => true);
}
